import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/[...slug]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/app/src/blocks/Code/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReadMore"] */ "/app/src/blocks/CompanyIntro/ReadMore.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactFormClient"] */ "/app/src/blocks/ContactForm/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FormBlock"] */ "/app/src/blocks/Form/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Gallery"] */ "/app/src/blocks/Gallery/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HighlightsCarousel"] */ "/app/src/blocks/Highlights/HighlightsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HolidayPackages"] */ "/app/src/blocks/HolidayPackages/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HotelsCarousel"] */ "/app/src/blocks/Hotels/HotelsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamCarousel"] */ "/app/src/blocks/Team/TeamCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UltimateAdventures"] */ "/app/src/blocks/UltimateAdventures/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "/app/src/components/Card/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/EmailObfuscator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LivePreviewListener"] */ "/app/src/components/LivePreviewListener/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/app/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/app/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HighImpactHero"] */ "/app/src/heros/HighImpact/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LowImpactHero"] */ "/app/src/heros/LowImpact/index.tsx");
